<template>
  <!--页脚-->
  <a-row class="foot">
      <a-col :span="19" style="height: 20vh;display: flex; align-items: center;justify-content: center">
        <a-row>
        <p style="font-size: 14px;margin-bottom: 0">Susquehanna International Group, LLP. </p>
          <p style="font-size: 14px;margin-bottom: 0">All rights reserved.</p>
          <p style="font-size: 14px;margin-bottom: 0">Susquehanna Financial Group, LLLP (SFG), </p>
          <p style="font-size: 14px;margin-bottom: 0">An affiliate of SIG, Is a member of FINRA.</p>
      </a-row>
      </a-col>
      <a-col :span="5" style="height: 20vh;padding-top: 5vh">
        <a-popover placement="top">
          <template #content>
            <img src="../../assets/qr.gif">
            <p style="color: black; font-size: 10px; margin-bottom: 0">微信扫二维码</p>
            <WechatFilled style="color: white; font-size: 3vh; padding-right: 1vw"/>
          </template>
          <WechatFilled style="color: white; font-size: 3vh; padding-right: 1vw"/>
        </a-popover>
        <WeiboCircleFilled style="color: white; font-size: 3vh;" @click="shareweibo"/>
      </a-col>
    </a-row>
</template>

<script>
import {WeiboCircleFilled, WechatFilled,} from '@ant-design/icons-vue'

export default {
  name: 'Footer_en_m',
  components: {WeiboCircleFilled, WechatFilled},
  setup() {
    const shareweibo = () => {
      let title = "海纳百川 投资团队"
      let url = encodeURIComponent(window.location.href);
      let sinaurl = 'http://service.weibo.com/share/share.php?url=' + url + '&type=button&language=zh_cn&title=' + title
          + '&searchPic=true&style=number#_loginLayer_1496300586101';
      window.open(sinaurl);
    }
    return {shareweibo}
  }
}
</script>

<style scoped>
.foot {
  background: black;
}
</style>